

const trapFocusHandlers = {};

const FOCUSABLE_SELECTOR =
  "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe";

function canTakeFocus(element) {
  if (element.tabIndex < 0 || element.matches(':disabled')) return false;

  for (let node = element; node; node = node.parentElement) {
    if (node.hasAttribute('hidden') || node.hasAttribute('inert')) return false;

    const parent = node.parentElement;
    if (parent instanceof HTMLDetailsElement && !parent.open && node !== parent.querySelector(':scope > summary')) {
      return false;
    }
  }

  return typeof element.checkVisibility === 'function'
    ? element.checkVisibility({ checkVisibilityCSS: true, visibilityProperty: true })
    : element.getClientRects().length > 0 && getComputedStyle(element).visibility === 'visible';
}

function getFocusableElements(container) {
  return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(canTakeFocus);
}

export function trapFocus(container) {

  removeTrapFocus();

  let backward = false;

  trapFocusHandlers.keydown = (event) => {
    if (event.key !== 'Tab') return;

    backward = event.shiftKey;

    const activeEl = document.activeElement;
    if (!activeEl || !container.contains(activeEl)) return;

    const ahead = backward ? Node.DOCUMENT_POSITION_PRECEDING : Node.DOCUMENT_POSITION_FOLLOWING;
    const focusable = getFocusableElements(container);
    if (!focusable.length || focusable.some((element) => activeEl.compareDocumentPosition(element) & ahead)) return;

    event.preventDefault();
    (backward ? focusable.at(-1) : focusable[0]).focus();
  };

  trapFocusHandlers.focusin = (event) => {

    if (!(event.target instanceof Node) || container.contains(event.target)) return;

    const focusable = getFocusableElements(container);
    const target = backward ? focusable.at(-1) : focusable[0];
    backward = false;

    if (!target) return;

    event.stopPropagation();
    target.focus();
  };

  document.addEventListener('keydown', trapFocusHandlers.keydown, true);

  document.addEventListener('focusin', trapFocusHandlers.focusin, true);

  if (!container.contains(document.activeElement)) container.focus();
}

export function removeTrapFocus() {
  trapFocusHandlers.keydown && document.removeEventListener('keydown', trapFocusHandlers.keydown, true);
  trapFocusHandlers.focusin && document.removeEventListener('focusin', trapFocusHandlers.focusin, true);
}

export function cycleFocus(items, increment) {
  const currentIndex = items.findIndex((item) => item.matches(':focus'));
  let targetIndex = currentIndex + increment;

  if (targetIndex >= items.length) {
    targetIndex = 0;
  } else if (targetIndex < 0) {
    targetIndex = items.length - 1;
  }

  const targetItem = items[targetIndex];

  if (!targetItem) return;

  targetItem.focus();
}
